"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKB = void 0;
exports.getKB = function (_a) {
    var x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2;
    var k = (y2 - y1) / (x2 - x1);
    var b = y1 - k * x1;
    return { k: k, b: b };
};
